import React, { useState,useContext } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Checkbox } from '@mui/material';
import thumsUpIcon from "./../../../assets/images/thumbs-up 1.svg";
import MessageIcon from "./../../../assets/images/messageIcon.svg";
import SelectIcon from "./../../../assets/images/Group.svg";
import styles from "./card.module.css";
import BackgroundImg from "./../../../assets/images/recommandationImg.svg";
import CustomTooltip from 'utils/CustomTooltip';
import FeedbackPopup from '../popup/FeedbackPopup';
import { getRecommendationKey } from 'utils/createRecommendationKey';
import { SelectedAlertsContext } from 'utils/SelectedAlertContext';

export default function OutlinedCard({
  alert,
  recommandationCard,
  selectedRecom,
  setSelectedRecom,
  alertDetails,
  alertType,
  isReadOnly
}) {
  const [recommendation, setRecommendation] = useState(alert);
  const [openFeedbackDrawer, setOpenFeedbackDrawer] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState({});
  const { selections, setSelections } = useContext(SelectedAlertsContext);

  let alertTypeKey="";
  if(alertTypeKey==='RMPM Alert'){
    alertTypeKey="rmpm";
  }

  const handleCheckboxChange = (event) => {
    const recommendationKey = getRecommendationKey(alert);

    if (event.target.checked) {
      setSelectedRecom((prev) => [...prev, { ...alert, uniqueKey: recommendationKey }]);
    } else {
      setSelectedRecom((prev) => prev.filter((item) => item.uniqueKey !== recommendationKey));
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return dateString;
    
    // Check if it's a date range (yyyy-mm-dd to yyyy-mm-dd)
    if (dateString.includes(' to ')) {
      const [startDate, endDate] = dateString.split(' to ').map(date => date.trim());
      const startDateMatch = startDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
      const endDateMatch = endDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
      
      if (startDateMatch && endDateMatch) {
        const [, startYear, startMonth, startDay] = startDateMatch;
        const [, endYear, endMonth, endDay] = endDateMatch;
        return `${startDay}-${startMonth}-${startYear} to ${endDay}-${endMonth}-${endYear}`;
      }
      return dateString;
    }
    
    // Single date format (yyyy-mm-dd with or without time)
    const dateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateMatch) {
      const [, year, month, day] = dateMatch;
      return `${day}-${month}-${year}`;
    }
    return dateString;
  };

  const formatDecimal = (value) => {
    if (value === null || value === undefined) {
      return 'N/A';
    }

    if (typeof value === 'number') {
      return value % 1 === 0 ? value.toString() : value.toFixed(1);
    }

    // Check if value is a date string in yyyy-mm-dd format and format it
    if (typeof value === 'string') {
      return formatDate(value);
    }

    return value;
  };

  const toggleFeedbackDrawer = (open) => {
    setSelectedAlert(alertDetails);
    setOpenFeedbackDrawer(open);
  };

  const handleFeedbackInCard = (feedback) => {
    setRecommendation(prev => ({ ...prev, Title: feedback }));
  };

  const recommendationKey = getRecommendationKey(alert);
  const isChecked = selectedRecom.some((item) => item.uniqueKey === recommendationKey);

  const displayTitle = recommendation.Title === 'Manual PO' && recommendation.Info
    ? recommendation.Info
    : recommendation.Title;

  return (
    <>
      {recommendation ? (
        <Box>
          <Card
            sx={{
              boxShadow: "0px 4px 8px 0px #959DA533",
              backgroundImage: `url(${BackgroundImg})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <CardContent sx={{ padding: '0px !important' }}>
              <div className={styles.cardHeader}>
                <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                  {recommendation.Title !== 'Other Recommendation' ? (
                    <Checkbox
                      sx={{
                        padding: 0,
                        height: '18px',
                        width: '18px',
                        '& .MuiSvgIcon-root': { fontSize: 18 },
                      }}
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      disabled={isReadOnly || alertDetails['Alert status'] === 'Closed' || alertDetails['Alert status'] === 'Accepted'}
                    />
                  ) : (
                    <img
                      src={MessageIcon}
                      alt="Feedback icon"
                      style={{ height: '20px', width: '20px' }}
                    />
                  )}
                  <span>{displayTitle}</span>
                </div>

                {recommendation?.isRecommended && (
                  <img src={thumsUpIcon} alt="Recommendation" height={16} width={16} />
                )}

                {recommendation.Title === 'Other Recommendation' && (
                  <img
                    src={SelectIcon}
                    alt="Feedback icon"
                    style={{
                      height: '20px', width: '20px',
                      cursor: (isReadOnly || alertDetails["Alert status"]==='Accepted')? "not-allowed" : "pointer",
                      opacity: (isReadOnly || alertDetails["Alert status"]==='Accepted')? 0.5 : 1,
                      pointerEvents: (isReadOnly && alertDetails["Alert status"]==='Accepted')?"none" : "auto"
                    }}
                    onClick={() => !isReadOnly && alertDetails["Alert status"]!=='Accepted' && toggleFeedbackDrawer(true)}
                  />
                )}

              </div>

              <div className={styles.cardBody}>
                {alert.data?.map((item, index) => {
                  const formattedValue = formatDecimal(item.value);
                  return (
                    <div key={index} className={styles.cardBodyContain}>
                      <span>{item.label}</span>
                      <span className={styles.ellipsisText}>
                        <CustomTooltip title={formattedValue}>
                          <span>{formattedValue}</span>
                        </CustomTooltip>
                      </span>
                    </div>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        </Box>
      ) : (
        <div>No recommendations available</div>
      )}

      <FeedbackPopup
        open={openFeedbackDrawer}
        onClose={() => {
          setOpenFeedbackDrawer(false);
          setSelectedAlert({});
        }}
        onConfirm={(feedback) => handleFeedbackInCard(feedback)}
        alertId={selectedAlert}
        type={alertType}
      />
    </>
  );
}